// Pie geometry, kept apart from the chart components so it runs under Node's test runner.

/** The SVG path of a pie slice from `start` to `end` (fractions of a turn, from 12 o'clock). */
export function slicePath(start: number, end: number, r: number, c = r): string {
  if (end - start >= 1) return `M ${c} ${c - r} A ${r} ${r} 0 1 1 ${c - 0.001} ${c - r} Z`;
  const point = (t: number) => {
    const a = 2 * Math.PI * t - Math.PI / 2;
    return `${(c + r * Math.cos(a)).toFixed(3)} ${(c + r * Math.sin(a)).toFixed(3)}`;
  };
  const large = end - start > 0.5 ? 1 : 0;
  return `M ${c} ${c} L ${point(start)} A ${r} ${r} 0 ${large} 1 ${point(end)} Z`;
}
